import React from "react";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import useStyles from "./styles";

export const CheckboxInput = ({
  id,
  size,
  label,
  checked,
  onChange,
  color,
  name,
  className,
  disabled,
  hidden,
  margin,
  value,
  policyInfoStyle,
  ...props
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <FormControlLabel
        classes={{
          label: policyInfoStyle
            ? classes.policyInfoLable
            : className === "defaultLable"
            ? classes.defaultLable
            : classes.defaultLable,
          root:
            className === "defaultLable"
              ? classes.defaultStyle + " " + margin
              : classes.defaultStyle + " " + margin,
        }}
        hidden={hidden}
        control={
          <Checkbox
            size={size}
            id={id}
            checked={checked}
            value={value}
            onChange={onChange}
            name={name}
            classes={{ root: disabled ? classes.defaultBox : classes.skyBox }}
            disabled={disabled}
            {...props}
          />
        }
        label={label}
      />
    </React.Fragment>
  );
};
